import _index from "./dist/index";
export { _index as default };
export const __esModule = _index.__esModule,
      sum = _index.sum;